var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityOfLifeSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.64 111.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5ce40;}.cls-2{fill:#50c1dc;}.cls-3{fill:#595145;}.cls-4{fill:#959492;}.cls-5{fill:#33b0d1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.82,
    cy: 56.33,
    r: 37.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,7c-2,1-3.13,4.48-.87,7.48s4.49,3.05,6.34,2,.93-3.93.29-5.35S29.85,5.1,26,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.16,42.44c-.7,2.12,1,5.38,4.67,5.9s5.34-1,5.87-3.09-2.12-3.44-3.57-4S1.49,38.36.16,42.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,85.76c1,2,4.48,3.13,7.48.87s3.06-4.49,2-6.34S12.42,79.36,11,80,5,81.93,6.9,85.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.31,111.62c2.12.7,5.37-1,5.89-4.67s-1-5.34-3.09-5.88-3.43,2.13-4,3.58S38.23,110.28,42.31,111.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.62,104.87c2-1,3.13-4.47.87-7.47s-4.49-3.06-6.34-2-.93,3.93-.29,5.35S81.79,106.81,85.62,104.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.48,69.47c.7-2.12-1-5.37-4.67-5.9s-5.33,1-5.87,3.09,2.12,3.44,3.57,4S110.15,73.55,111.48,69.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.74,26.15c-1-2-4.48-3.12-7.48-.86s-3.05,4.49-2,6.34,3.94.92,5.36.29S106.68,30,104.74,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.54.31c-2-.95-5.45.29-6.43,3.91s.35,5.42,2.35,6.21,3.67-1.69,4.4-3.06S82.42,2.14,78.54.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.36,41.5A40.32,40.32,0,0,0,82,36.79C77.78,28.45,69.38,12.43,67.86,11,66,9.33,60.69,8.77,61,11.59s5.13,4.55,6.62,9.11c1.81,5.6,5.69,16.75,4.48,24.26-1.34,8.3-4.25,12.91-8.37,10.22s-6-3.17-11.43-2.51S38.37,45.08,33.26,42,19.43,31.44,18.2,28.17s-7.83-11.3-9.42-8.35-.45,6,3.76,10.1,6.5,11.3,8.63,16.85a15.11,15.11,0,0,0,1.24,2.48h0c.18.3.38.6.58.89h0c.21.29.42.57.65.85l0,0c.22.27.45.54.7.81l0,0q.36.39.75.78l.05.05.79.74.07.06c.27.24.55.47.84.71l.1.08c.28.22.56.45.86.67l.14.1c.29.22.58.43.89.64l.18.13.9.6.25.16.9.56.33.19c.28.18.57.35.87.52l.46.26.8.45.66.35.66.36,1.38.71C43.87,63.82,48.1,74.51,48.7,78.05a1.25,1.25,0,0,1,0,.19h0c0,.34.07.66.09,1a.31.31,0,0,1,0,.1c.28,5.3-3,9.37-3.3,13.22A37.7,37.7,0,0,0,55.91,94c.72,0,1.44,0,2.16-.08h.21c.7-.05,1.38-.11,2.06-.19h0a37.15,37.15,0,0,0,8.32-2l.13,0a38.68,38.68,0,0,0,4.06-1.78l.32-.16c.56-.3,1.12-.6,1.67-.93a1.71,1.71,0,0,0,.23-.13c.61-.36,1.2-.74,1.78-1.13l.33-.23c.46-.32.92-.65,1.37-1L79,86c.54-.42,1.07-.85,1.59-1.3,0-.66,0-1.33,0-2,0-2-.07-4.12-.07-6.11,0-1.33,0-2.62.1-3.82a29.89,29.89,0,0,1,.35-3.3C81.8,64.65,85.73,44.47,84.36,41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.26,43.08c.54,2.61.67,8.06,0,9.59s2.95,7.13,7.45,6.18,2.85-4,2-6-1.26-9.24-.57-13.07S52.26,43.08,52.26,43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.59,33.86a23.22,23.22,0,0,0,3.91,8.69,14.71,14.71,0,0,0,4.06,3.06c3.31,1.6,7,2.48,8.83,1.39s2.13-8.71,1.32-14.51S59.6,21.93,55.18,21.85,44,24.16,45.59,33.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.2,28.17c-1.23-3.26-7.83-11.3-9.42-8.35s-.45,6,3.76,10.1a21.15,21.15,0,0,1,3.66,5,12.34,12.34,0,0,0,3.43-4.52A8.75,8.75,0,0,1,18.2,28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.18,21.85c-4.43-.07-11.22,2.31-9.59,12a17.33,17.33,0,0,0,2.82,7.07c2.81-2.14-1.4-6.46.22-9.82s7.67-.81,12.76-5.23C59.85,23.46,57.7,21.9,55.18,21.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.87,9.78c-.26,2.83,7.4,8.18,8.73,10.92h0a9.25,9.25,0,0,0,4.07-3.5c-1.82-3.26-3.68-7-4.23-7.49C65.6,8,59.43,3.55,58.87,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.36,41.5A35.57,35.57,0,0,0,81,35.3c2.45,5.54-1.68,17.57-4,19.7-3.33,3-3.55,11.59-3.83,22.27S57.6,85.44,55.81,81.49,50.87,66.72,45.87,63,24.56,52.92,21.43,47.37C23.7,52.58,28.88,56.24,36.29,60c7.71,3.9,12,14.89,12.44,18.25.85,5.84-2.85,10.21-3.19,14.32a37.64,37.64,0,0,0,35.05-7.87c0-5.28-.34-11.3.36-15.24C81.8,64.65,85.73,44.47,84.36,41.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityOfLifeSection);
export default __webpack_public_path__ + "static/media/quality_of_life_section.63d7a38d958f7a57146ad305b642eae3.svg";
export { ForwardRef as ReactComponent };